(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const announcementBarSlider = new Swiper('.announcement-bar', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const openSearch = document.querySelectorAll('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');

  const menuDrawer = document.querySelector("menu-drawer")

  openSearch.forEach((s) => {
    s.addEventListener('click', () => {
    if (search.classList.contains('is-visible')) {
      search.classList.remove('is-visible');
      s.classList.remove('opacity-50')
    } else {
      search.classList.add('is-visible');
      menuDrawer.closeMenuDrawer()
      s.classList.add('opacity-50')
    }
  })
})

  closeSearch?.addEventListener('click', () => {
    search.classList.remove('is-visible');
    s.classList.remove('opacity-50')
  }); 

  let scrollpos = window.scrollY
  const header = document.querySelector(".header-wrapper")
  const header_height = header.offsetHeight
  const backToTop = document.querySelector("back-to-top")

  const add_class_on_scroll = () => {header.classList.add("border-b-half", "border-green"); backToTop.classList.add("!visible","!block","opacity-100")}
  const remove_class_on_scroll = () => {header.classList.remove("border-b-half", "border-green"); backToTop.classList.remove("!visible","!block","opacity-100")}

  window.addEventListener('scroll', function() { 
    scrollpos = window.scrollY;

    if (scrollpos >= header_height) { add_class_on_scroll() }
    else { remove_class_on_scroll() }

  })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-carousel"] && !Shopify.designMode) return;
  try {
    

const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Main product slider
  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 0,
    allowTouchMove: false
  });

  const thumbnailImages = document.querySelectorAll("[data-product-thumb]")

  thumbnailImages.forEach(thumb => {
    thumb.addEventListener('click', function(e) {
      productSlider.slideTo(e.target.dataset.productThumb);
    });
  });

  // Hover effect for main image
  const mainImageWrapper = document.querySelector('.product__media-list');
  if (mainImageWrapper) {
    mainImageWrapper.classList.remove('pointer-events-none'); // Enable pointer events for hover
    mainImageWrapper.addEventListener('mouseenter', () => {
      // Check if there is a second image (index 1) in the media list
      if (productSlider.slides.length > 1) {
        productSlider.slideTo(1); // Switch to the second image
      }
    });
    mainImageWrapper.addEventListener('mouseleave', () => {
      productSlider.slideTo(0); // Revert to the first image
    });
  }

  const sizeGuideTrigger = document.querySelector('[data-micromodal-trigger="size-guide"]');
  if (sizeGuideTrigger) {
    sizeGuideTrigger.addEventListener('click', (e) => {
    e.preventDefault()
    MicroModal.show(`${e.target.dataset.micromodalTrigger}`)
  })
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["post-carousel"] && !Shopify.designMode) return;
  try {
    
  const postsCarousels = document.querySelectorAll('.swiper[data-posts-carousel]') || null

  if( postsCarousels ) {
    postsCarousels.forEach(carousel => {
      const swiper = new Swiper(carousel, {
        slidesPerView: 1.125,
        spaceBetween: 16,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          600: {
            slidesPerView: 4,
            spaceBetween: 16
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 16
          },
          1439: {
            slidesPerView: 4,
            spaceBetween: 16
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev', 
        }
      })
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            if (this.querySelector('.is-slider')) this.initSlider();
          }
        })
        .catch(e => console.error('Product recommendations error:', e));
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }

  initSlider() {
  const slider = this.querySelector('.recommendation-slider');
  const slides = Array.from(slider.querySelectorAll('.slide'));
  const prevBtn = this.querySelector('.slider-btn.prev');
  const nextBtn = this.querySelector('.slider-btn.next');
  let currentIndex = 0;
    // Get slides per view dynamically
  const getSlidesPerView = () => {
    if (window.innerWidth < 768) return 1.6;
    if (window.innerWidth < 1024) return 2;
    return 4;
  };
  let slidesPerView = getSlidesPerView();



  const totalSlides = slides.length;

  const updateButtons = () => {
    const maxIndex = totalSlides - slidesPerView;
    prevBtn.disabled = currentIndex <= 0;
    nextBtn.disabled = currentIndex >= maxIndex;
  };

  const updateSlider = () => {
    const offset = -(currentIndex * (100 / slidesPerView));
    slider.style.transform = `translateX(${offset}%)`;
    updateButtons();
  };

  nextBtn?.addEventListener('click', () => {
    if (currentIndex < totalSlides - slidesPerView) {
      currentIndex++;
      updateSlider();
    }
  });

  prevBtn?.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  });

  // Drag functionality
  let startX = 0;
  let isDragging = false;

  slider.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX;
  });

  window.addEventListener('mouseup', (e) => {
    if (!isDragging) return;
    const diff = e.pageX - startX;
    if (diff > 50 && currentIndex > 0) currentIndex--;
    if (diff < -50 && currentIndex < totalSlides - slidesPerView) currentIndex++;
    updateSlider();
    isDragging = false;
  });

  // Responsive handling
  window.addEventListener('resize', () => {
    slidesPerView = this.getSlidesPerView();
    updateSlider();
  });

  updateSlider();
}

}

customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
